import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

export const ShortLabel = styled(KizenTypography)`
  && {
    margin-bottom: -2px;
  }
`;
